module.exports = __webpack_public_path__ + "static/image6-79213f23069fd0fc8f21a9281ef01e8f.jpg";